export default "/static/build/mcafee.png";